<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   xmlns="http://www.w3.org/2000/svg"
   width="18"
   height="24"
   viewBox="0 0 18 24"
   version="1.1"
   id="svg8">
  <defs
     id="defs2">
    <pattern
       y="0"
       x="0"
       height="6"
       width="6"
       patternUnits="userSpaceOnUse"
       id="EMFhbasepattern" />
    <pattern
       y="0"
       x="0"
       height="6"
       width="6"
       patternUnits="userSpaceOnUse"
       id="EMFhbasepattern-7" />
    <pattern
       y="0"
       x="0"
       height="6"
       width="6"
       patternUnits="userSpaceOnUse"
       id="EMFhbasepattern-0" />
  </defs>
  <g
     id="layer1"
     transform="translate(0,-290.65)"
     style="display:none">
    <circle
       style="opacity:1;vector-effect:none;fill:none;fill-opacity:1;fill-rule:nonzero;stroke:#000000;stroke-width:0.03341123;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
       id="path4752"
       cx="9.0642443"
       cy="302.68155"
       r="4.9517455" />
    <rect
       style="opacity:1;vector-effect:none;fill:none;fill-opacity:1;fill-rule:nonzero;stroke:#000000;stroke-width:0.05;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
       id="rect4754"
       width="36"
       height="36"
       x="-8.9357557"
       y="284.68155" />
    <circle
       style="opacity:1;vector-effect:none;fill:none;fill-opacity:1;fill-rule:nonzero;stroke:#000000;stroke-width:0.05;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
       id="path4756"
       cx="9.0642443"
       cy="302.68155"
       r="18" />
    <rect
       style="opacity:1;vector-effect:none;fill:none;fill-opacity:1;fill-rule:nonzero;stroke:#000000;stroke-width:0.03321357;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
       id="rect4760"
       width="7.9622984"
       height="7.9802246"
       x="5.0322967"
       y="298.65317" />
  </g>
  <g
     id="layer2"
     style="display:inline">
    <g
       id="g5744"
       transform="matrix(3.7795275,0,0,3.7795275,-368.99999,-648.51962)">
      <rect
         y="169.99998"
         x="95.25"
         height="9.5250015"
         width="9.5249996"
         id="rect10299-4"
         style="opacity:1;fill:none;fill-opacity:1;stroke:none;stroke-width:0.39687493;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" />
      <path
         style="opacity:1;vector-effect:none;fill-opacity:1;fill-rule:nonzero;stroke:none;stroke-width:0.26458335;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
         d="m 100.76086,173.63996 -0.74836,0.74835 -0.748352,-0.74835 -0.374178,0.37417 0.748355,0.74836 -0.748355,0.74835 0.374178,0.37418 0.748352,-0.74836 0.74836,0.74836 0.37417,-0.37418 -0.74835,-0.74835 0.74835,-0.74836 z"
         id="rect6052" />
    </g>
  </g>
</svg>
